import { ServerEventMessage } from './pusher-message.model';

export const PUSHER_CHUNK_MESSAGE_TYPE = 'PUSHER_MESSAGE_CHUNK';

interface ChunkedMessageObject {
  chunked_message_id: string;
  chunk_index: number;
  total_chunks: number;
  chunk_data: string;
}

export interface ChunkedServerEventMessage extends ServerEventMessage<ChunkedMessageObject> {
  message_type: typeof PUSHER_CHUNK_MESSAGE_TYPE;
}
